module.exports = __webpack_public_path__ + "img/promo-ertiga.074f26a7.jpg";